import { createRemoteConfigAtomFactory } from '@exodus/remote-config-atoms';
export const defaultValue = {
    'li-fi': {
        enabled: true,
    },
    jupiter: {
        enabled: true,
    },
    exodus: {
        enabled: true,
    },
    rango: {
        enabled: true,
    },
};
const createExchangeRemoteConfigAtom = ({ remoteConfig }) => createRemoteConfigAtomFactory({ remoteConfig })({
    defaultValue,
    path: 'infrastructure.exchange.v3',
});
export default createExchangeRemoteConfigAtom;
